export const GOOGLE_MAPS_API_KEY = "AIzaSyCtxxugJ7TYBmt2vZzCjptF8K-jto9vRyk";
export const MAX_CORNER_MARKERS = 3;
export const DEFAULT_ZOOM = 18;
